import { ICON__list_check, ICON__list_x } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD__list_token;
}

export function G_BUTTON__prompt_select_all_tokens({ field }: PROPS) {
  /*
   *
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */

  const are_all_items_selected = useMemo(() => get_are_all_items_selected(), [field]);

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();

    let need_hide_all = are_all_items_selected;

    let tokens_new = [];

    for (let token of field.items) {
      let token_new = token.clone();

      token_new.is_hidden.set_value(need_hide_all);

      tokens_new.push(token_new);
    }

    field_new.items = tokens_new;

    /*
     *
     */

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }
  /*
   *
   */

  /*
   *
   */
  function get_are_all_items_selected() {
    let tokens_enabled = field.items.filter(item => !item.is_hidden.get_value());

    return tokens_enabled.length == field.items.length;
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      size="3-full"
      variant="no-border-on-bar"
      iconClassNameBase="!text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      {...{ onClick }}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={are_all_items_selected ? ICON__list_x : ICON__list_check}
    />
  );
}
